import { Gym, TimeSlotType } from 'fitbeat.models';
import { INotificationService } from 'fitbeat.notification-service';
import { CurrentWorkoutSelectionManager, WorkoutProgramRecommendations } from '../logic';
import {
  WorkoutSelectionManager,
} from '../logic/workoutselection/workoutselectionmanager';
import {
  CachedExerciseRepository,
  CachedGymTimeSlotsRepository,
  DBCurrentWorkoutSelectionRepository,
  DbGymRepository,
  DbGymTimeSlotsRepository,
  DbUserProfileRepository,
  DbWorkoutRepository,
  ICurrentWorkoutSelectionRepository,
  IExerciseRepository,
  IGymTimeSlotsRepository,
  InMemoryCurrentWorkoutSelectionRepository,
  InMemoryGymTimeSlotsRepository,
  InMemoryUserProfileRepository,
  InMemoryWorkoutRepository,
  InMemoryWorkoutSelectionRepository,
  IUserProfileRepository,
  IWorkoutRepository,
  IWorkoutSelectionRepository,
  JsonExerciseRepository,
  JsonWorkoutRepository,
} from '../persistence';

import { CardioOrResistance, Exercise, Level } from '../entities/exercise/exercise';
import { InMemoryGymSchedule } from '../entities/gymschedule/inmemorygymschedule';
import { UserProfile } from '../entities/user';
import { WorkoutSettings } from '../entities/user/workoutsettings';
import { UserWorkoutSession } from '../entities/workoutsession/userworkoutsession';
import { GymScheduler } from '../logic/gymscheduling/gymscheduling';
import { TimeSlices } from '../logic/gymscheduling/timeslices';
import { Metrics } from '../metrics';

const coupleNames = [
  ['Noriko (couple)', 'Michaele (couple)', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: true,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Zofia (couple)', 'Celestine (couple)', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: true,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Delinda (couple)', 'Rosaura (couple)', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: true,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Erich (couple)', 'Juliette (couple)', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Ami (couple)', 'Tiny (couple)', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Burt (couple)', 'Willa (couple)', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Beverlee (couple)', 'Elvina (couple)', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Keisha (couple)', 'Alda (couple)', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Margarite (couple)', 'Rex (couple)', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Beatris (couple)', 'Shawna (couple)', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Resistance,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Owen (couple)', 'Sixta (couple)', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Resistance,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Shannan (couple)', 'Beryl (couple)', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Resistance,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Palmer (couple)', 'Ashley (couple)', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Arielle (couple)', 'Olympia (couple)', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Eliana (couple)', 'Earleen (couple)', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Irwin (couple)', 'Alise (couple)', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Alexa (couple)', 'Keitha (couple)', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Leoma (couple)', 'Roosevelt (couple)', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Bernardine (couple)', 'Lauran (couple)', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Ashely (couple)', 'Keenan (couple)', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
];

const sinlgeNames = new Map<string, WorkoutSettings>([
  ['Alice', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: true,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Bob', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: true,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Charl', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: true,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Dave', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Ella', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Fane', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Gale', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Harry', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Irma', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Jake', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Kale', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Liam', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Mia', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Resistance,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Nads', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Resistance,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Ollie', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Resistance,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Pete', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Quince', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Ria', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Steve', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Tilly', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Uma', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Vic', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Walt', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Xeny', new WorkoutSettings({
    level: Level.Expert,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Yara', new WorkoutSettings({
    level: Level.Basic,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
  ['Zach', new WorkoutSettings({
    level: Level.Intermediate,
    allowBagContact: false,
    cardioOrResistance: CardioOrResistance.Cardio,
    threeBodyGroups: ['Lower', 'Upper'],
  })],
]);

export class Simulation implements IExerciseRepository {
  private testNo = 0;

  private jsonExerciseRepository: IExerciseRepository = new CachedExerciseRepository(new JsonExerciseRepository());

  private inMemoryWorkoutSelectionRepository: IWorkoutSelectionRepository = new InMemoryWorkoutSelectionRepository();

  constructor(private gym: Gym) {
  }

  public TestSetup(
    cycleTimeInSeconds: number,
    startAt: Date = new Date(),
    hoursToRunFor = 24,
    options: any = {},
  ): Promise<GymScheduler> {
    return this.TestSetupWithData(
      cycleTimeInSeconds,
      [],
      startAt,
      hoursToRunFor,
      options,
      DbGymRepository.getTestGym(),
    );
  }

  public add(exercise: Exercise): Promise<void> {
    throw new Error('Method not implemented.');
  }

  public getAll(): Promise<Exercise[]> {
    return this.jsonExerciseRepository.getAll();
  }

  public get(id: string): Promise<Exercise | undefined> {
    return this.jsonExerciseRepository.get(id);
  }

  public async TestWorkoutSelection(gym: Gym, amountOfStages = 10, amountOfStations = 20)
    : Promise<UserWorkoutSession[]> {
    const workoutSessions = new Array<UserWorkoutSession>();
    function buildLogger() {
      // tslint:disable-next-line:no-console
      return console.log;
    }
    const currentWorkoutSelectionRepository = new InMemoryCurrentWorkoutSelectionRepository();
    for (const [userName, settings] of sinlgeNames) {
      const workoutSession = new UserWorkoutSession(userName, amountOfStages, settings);
      const workoutRepository = new InMemoryWorkoutRepository();
      const userProfileRepository = new InMemoryUserProfileRepository();
      const workoutProgramRecommendations = new WorkoutProgramRecommendations(
        workoutRepository,
        userProfileRepository,
        console.log,
      );
      const scheduler = new GymScheduler(
        120,
        new InMemoryGymSchedule(),
        new Date(),
        workoutRepository,
        new Date(),
        24,
        new WorkoutSelectionManager(
          this,
          this.inMemoryWorkoutSelectionRepository,
          currentWorkoutSelectionRepository,
        ),
        userProfileRepository,
        buildLogger(),
        CurrentWorkoutSelectionManager.initializeInBackground(
          currentWorkoutSelectionRepository,
          this.inMemoryWorkoutSelectionRepository,
          buildLogger,
        ),
        new InMemoryGymTimeSlotsRepository(),
        workoutProgramRecommendations,
      );
        // need to queue in scheduler to assign zones
      await scheduler.QueueSession(workoutSession, gym);
      workoutSessions.push(workoutSession);
    }
    return workoutSessions;
  }

  public TestSetupWithData(
    cycleTimeInSeconds: number,
    initialStateNames: string[],
    initialDateTime: Date,
    hoursToRunFor: number,
    options: any = {},
    gym: Gym,
    notificationService?: INotificationService,
  ): Promise<GymScheduler> {
    this.TestTimeSlices();

    function buildLogger() {
      if (process.env.TESTS) {
        return () => {
          // no-op
        };
      }
      // tslint:disable-next-line:no-console
      return console.log;
    }

    function buildWinstonLogger() {
      return {
        info: buildLogger(),
        warn: buildLogger(),
        error: buildLogger(),
      };
    }

    const buildRepository = (): IWorkoutRepository => {
      if (process && process.env) {
        if (process.env.REPOSITORY === 'JSON') {
          return new JsonWorkoutRepository();
        }
        if (process.env.REPOSITORY === 'DB') {
          return new DbWorkoutRepository(options.workoutsPouch, options.generalSettingsPouch, {
            info: buildLogger(),
            warn: buildLogger(),
          });
        }
      }
      return new InMemoryWorkoutRepository();
    };

    const buildUserRepository = (): IUserProfileRepository => {
      if (process && process.env && process.env.REPOSITORY === 'DB') {
        return new DbUserProfileRepository(options.usersPouch);
      }
      return new InMemoryUserProfileRepository();
    };

    const buildGymTimeSlotsRepository = (): IGymTimeSlotsRepository => {
      if (process && process.env && process.env.REPOSITORY === 'DB') {
        const dbGymTimeSlotsRepository = new DbGymTimeSlotsRepository(options.generalSettingsPouch, {
          info: buildLogger(),
        });
        return new CachedGymTimeSlotsRepository(dbGymTimeSlotsRepository);
      }
      return new InMemoryGymTimeSlotsRepository();
    };

    const buildCurrentWorkoutRepository = (): ICurrentWorkoutSelectionRepository => {
      if (options.currentWorkoutPouch) {
        return options.currentWorkoutPouch;
      }
      if (process && process.env && process.env.REPOSITORY === 'DB') {
        return new DBCurrentWorkoutSelectionRepository(options.generalSettingsPouch, {
          info: buildLogger(),
        });
      }
      return new InMemoryCurrentWorkoutSelectionRepository();
    };

    const buildScheduler = (): Promise<GymScheduler> => new Promise((resolve) => {
      const gymSchedule = new InMemoryGymSchedule();
      const currentWorkoutSelectionRepo = buildCurrentWorkoutRepository();
      const workoutRepository = buildRepository();
      const userProfileRepository = buildUserRepository();
      const workoutProgramRecommendations = new WorkoutProgramRecommendations(
        workoutRepository,
        userProfileRepository,
        console.log,
      );
      const workoutSelection = new WorkoutSelectionManager(
        this,
        this.inMemoryWorkoutSelectionRepository,
        currentWorkoutSelectionRepo,
      );
      const currentWorkoutSelection = CurrentWorkoutSelectionManager.initializeInBackground(
        currentWorkoutSelectionRepo,
        this.inMemoryWorkoutSelectionRepository,
        buildLogger,
      );
      const gymCycles = new GymScheduler(
        cycleTimeInSeconds,
        gymSchedule,
        initialDateTime,
        buildRepository(),
        initialDateTime,
        hoursToRunFor,
        workoutSelection,
        buildUserRepository(),
        buildWinstonLogger(),
        currentWorkoutSelection,
        buildGymTimeSlotsRepository(),
        workoutProgramRecommendations,
        undefined,
        notificationService,
      );
      resolve(gymCycles);
    });

    return buildScheduler()
      .then((scheduler) => this.queueAllSessions(scheduler, initialStateNames, initialDateTime, gym));
  }

  public queueSession(
    gymCycles: GymScheduler,
    i: number,
    initialStateNames: string[],
    initialDateTime: Date,
    gym: Gym,
  ): Promise<boolean> {
    if (!(initialStateNames[i] !== 'Empty' && initialStateNames[i] !== '')) {
      return Promise.resolve(false);
    }

    const name = initialStateNames[i].split('-')[0];
    const currentRotation = parseInt(initialStateNames[i].split('-')[1], 10);
    let numberOfRotations = initialStateNames.length / 2;
    if (initialStateNames[i].split('-')[2]) {
      numberOfRotations = parseInt(initialStateNames[i].split('-')[2], 10);
    }
    const workout = new UserWorkoutSession(
      name,
      numberOfRotations,
      new WorkoutSettings(),
      currentRotation,
      initialDateTime,
    );
    return gymCycles.QueueSession(workout, gym, i);
  }

  public queueNextSession(
    gymCycles: GymScheduler,
    index: number,
    initialStateNames: string[],
    initialDateTime: Date,
    gym: Gym,
  ): Promise<GymScheduler> {
    if (index < initialStateNames.length) {
      return this.queueSession(gymCycles, index, initialStateNames, initialDateTime, gym)
        .then(() => this.queueNextSession(gymCycles, index + 1, initialStateNames, initialDateTime, gym));
    }

    return Promise.resolve(gymCycles);
  }

  public queueAllSessions(
    gymCycles: GymScheduler,
    initialStateNames: string[],
    initialDateTime: Date,
    gym: Gym,
  ): Promise<GymScheduler> {
    return this.queueNextSession(gymCycles, 0, initialStateNames, initialDateTime, gym);
  }

  public TestNext(
    gymCycles: GymScheduler,
    amountOfStages: number,
    queueAt: Date = new Date(),
    gym: Gym,
    name?: string,
    preferredStationIndex?: number,
    staticZoneType?: number,
  ): Promise<boolean> {
    const singleNamesIndexes = Array.from(sinlgeNames.keys());
    const session = new UserWorkoutSession(
      name || singleNamesIndexes[this.testNo % singleNamesIndexes.length],
      amountOfStages,
      sinlgeNames.get(singleNamesIndexes[this.testNo % singleNamesIndexes.length]),
      1,
      queueAt,
    );

    return gymCycles.QueueSession(
      session,
      gym,
      preferredStationIndex,
      staticZoneType,
    )
      .then((result: boolean) => {
        if (result) {
          ++this.testNo;
        }
        return result;
      });
  }

  public TestNextPair(
    gymCycles: GymScheduler,
    amountOfStages: number,
    gym: Gym,
    queueAt: Date = new Date(),
  ): Promise<boolean> {
    const queue = gymCycles.QueuePairSession(
      new UserWorkoutSession(
        coupleNames[this.testNo % coupleNames.length][0] as string,
        amountOfStages,
        new WorkoutSettings(),
        // coupleNames[this.testNo % coupleNames.length][2] as WorkoutSettings
        1,
        queueAt,
      ),
      new UserWorkoutSession(
        coupleNames[this.testNo % coupleNames.length][1] as string,
        amountOfStages,
        new WorkoutSettings(),
        // coupleNames[this.testNo % coupleNames.length][2] as WorkoutSettings
        1,
        queueAt,
      ),
      gym,
    );

    return queue
      .then((result) => {
        if (result) {
          ++this.testNo;
        }
        return result;
      });
  }

  public TestTimeSlices() {
    const hourSlices = new TimeSlices(new Date(), 60 * 60);

    const halfHourAfterStartOfDay = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      0,
      30,
      0,
    );

    const closestSlice = hourSlices.nextSliceClosestToTime(
      halfHourAfterStartOfDay,
    );
    if (!closestSlice) {
      throw new Error('Expected closest slice to not be undefined');
    }
    if (closestSlice.getHours() !== 1) {
      throw new Error('Expected to match the first hour slice from half hour');
    }
    const oneAm = closestSlice;

    const nextSlice = hourSlices.nextSliceClosestToTime(oneAm);
    if (!nextSlice) {
      throw new Error('Expected next slice to not be undefined');
    }
    if (nextSlice.getHours() !== 2) {
      throw new Error(
        'Expected to match the second hour as next from first hour',
      );
    }

    let fiveAm = hourSlices.getFutureCycleFrom(oneAm, 4);
    if (!fiveAm) {
      throw new Error('Expected next slice to not be undefined');
    }
    if (fiveAm.getHours() !== 5) {
      throw new Error(
        'Expected to match the fifth hour',
      );
    }

    fiveAm = hourSlices.getFutureHourCycleFrom(oneAm, 4);
    if (!fiveAm) {
      throw new Error('Expected next slice to not be undefined');
    }
    if (fiveAm.getHours() !== 5) {
      throw new Error(
        'Expected to match the fifth hour',
      );
    }
  }

  public Metrics(gymSchedule: GymScheduler) {
    return new Metrics(gymSchedule, this.gym);
  }

  public async addUserProfile(id: string, timeSlotType: TimeSlotType, gymSchedule: GymScheduler, options: any = {}) {
    const profile = Object.assign(new UserProfile(), {
      uid: id,
      timeSlotType,
      ...options,
    });
    return gymSchedule.userProfileRepository.add(profile);
  }
}
